import React from "react";
import ObsIframe from "../../../iframe-component/onboarding/ObsIframe";

const Withdrawn = () => {
  return <ObsIframe path="/tasklist/withdraw-task" />;
};

export default React.memo(Withdrawn);
